var _style, _circle, _g, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFEEEE;}\n\t.st1{fill:#E11D48;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30,
    cy: 30,
    r: 27.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.9,38.1c-0.1,0.6-0.2,1.2-0.5,1.7c-0.9,1.9-2.4,2.9-4.6,2.9c-3.8,0-7.8,0-11.6,0c-2,0-4.1,0-6,0 c-1.6,0-2.9-0.6-3.9-1.9c-1.3-1.6-1.5-3.4-0.7-5.2c0.7-1.5,1.6-3,2.6-4.4c2.2-3.8,4.4-7.5,6.5-11.4c0.8-1.4,2-2.2,3.5-2.6 c1.7-0.3,3.9,0.5,4.9,2c1,1.6,2,3.4,3,5.1c2,3.5,4.1,7,6,10.5c0.5,0.8,0.8,1.6,0.9,2.4C43.9,37.7,43.9,37.9,43.9,38.1z M30,40.4 c2.9,0,5.9,0,8.8,0c0.8,0,1.6-0.2,2.2-0.8c0.8-0.9,1-2.2,0.3-3.4c-2.3-4.1-4.6-8.1-7.1-12.2c-0.7-1.2-1.3-2.3-2-3.4 c-0.6-0.9-1.4-1.3-2.4-1.2c-0.9,0.1-1.6,0.6-2.1,1.5c-2.3,4.1-4.6,8-7,12c-0.7,1.2-1.4,2.3-2,3.6c-0.5,0.9-0.3,1.9,0.2,2.7 c0.6,0.8,1.4,1.2,2.4,1.2C24.1,40.4,27.1,40.4,30,40.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.4,26.7c-0.1,1.9-0.2,3.8-0.3,5.7c0,0.2,0,0.6,0,0.8c-0.1,0.5-0.6,0.9-1,0.9c-0.5,0-0.9-0.3-1-0.9 c-0.1-0.7-0.1-1.4-0.1-2.1c-0.1-1.5-0.1-2.9-0.2-4.4c-0.1-1.2,1-2.1,2.1-1.6C31.3,25.5,31.5,26,31.4,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30,38c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4C31.4,37.4,30.8,38,30,38z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 101.4,
    cy: -49.7,
    r: 27.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.7-37.7c-0.7,0-1.4-0.3-1.9-0.8s-0.8-1.2-0.8-1.9v-17.4h-1.3v-2.7h6.7v-1.3h8v1.3h6.7v2.7h-1.3v17.4 c0,0.7-0.3,1.4-0.8,1.9c-0.5,0.5-1.2,0.8-1.9,0.8H94.7z M108.1-57.8H94.7v17.4h13.4V-57.8z M97.4-43.1h2.7v-12h-2.7V-43.1z  M102.8-43.1h2.7v-12h-2.7V-43.1z M94.7-57.8v17.4V-57.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b76de05e01a125f42e70adb786f58a31.svg";
export { ForwardRef as ReactComponent };